var img = "/static/2cf8e8f9f7ee66c4.png";

export { img as default };
//# sourceMappingURL=logout.png.js.map
